// @flow

//
// Lodash
//
import fp from 'lodash/fp';

//
// Duck
//
import { type State } from './reducer';

//
// Selectors
//
const getData = (state: State) => state;

export const createSelectors = (localState: (state: any) => State): any => {
    return {
        getData: fp.compose(getData, localState),
    };
};
